import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import AudioPlayer from '../Player/AudioPlayer';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();

  const navItems = [
    { path: '/', label: '首页', icon: '🏠' },
    { path: '/live', label: '直播', icon: '📻' },
    { path: '/programs', label: '节目', icon: '📋' },
    { path: '/favorites', label: '收藏', icon: '⭐' },
    { path: '/profile', label: '我的', icon: '👤' },
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100">
      {/* 顶部 */}
      <header className="bg-gray-900 text-white py-3 px-4 sticky top-0 z-40 border-b border-gray-800">
        <h1 className="text-lg font-bold">
          香港电台CF版
        </h1>
      </header>

      {/* 页面内容 */}
      <main className="pb-24">
        {children}
      </main>

      {/* 底部导航 */}
      <nav className="fixed bottom-0 left-0 right-0 bg-gray-900/95 backdrop-blur-md border-t border-gray-800 safe-area-pb z-40">
        <div className="flex justify-around py-2">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={clsx(
                'flex flex-col items-center px-3 py-1 rounded-lg transition-colors',
                location.pathname === item.path
                  ? 'text-rthk-red'
                  : 'text-gray-400 hover:text-gray-200'
              )}
            >
              <span className="text-xl">
                {item.icon}
              </span>

              <span className="text-xs mt-1">
                {item.label}
              </span>
            </Link>
          ))}
        </div>
      </nav>

      {/* 播放器 */}
      <AudioPlayer />
    </div>
  );
}
